import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, ErrorStateMatcher } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../../../../../app/core/_base/crud';
import { PackagesHttpService } from '../../../../../app/core/packages';
var EditFileDialogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(EditFileDialogComponent, _super);
    function EditFileDialogComponent(dialogRef, data, http) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.data = data;
        _this.http = http;
        _this.viewLoading = false;
        _this.matcher = new ErrorStateMatcher();
        _this.availableVersions = [];
        _this.compVersions = [];
        _this.types = [
            { text: 'UI', value: 'ui' },
            { text: 'Menu', value: 'menu' },
            { text: 'VMC', value: 'aux' }
        ];
        _this.modeSelect = new FormControl(null, [Validators.required]);
        _this.desc = new FormControl('');
        _this.modes = [
            { text: 'Engg Review', value: 'engg' },
            { text: 'Current', value: 'curr' },
            { text: 'Archived', value: 'arch' }
        ];
        _this.modeOptions = [
            { value: 'engg', label: 'Engg Review' },
            { value: 'curr', label: 'Current' },
            { value: 'arch', label: 'Archived' }
        ];
        _this.availableColors = [
            { name: 'v0.1.0' },
            { name: 'v0.1.1' },
            { name: 'v0.1.2' },
            { name: 'v0.1.3' }
        ];
        return _this;
    }
    EditFileDialogComponent.prototype.ngOnInit = function () {
        //   console.log("Printing list",this.data);
        this.modeSelect.setValue(this.data.file_mode);
        this.desc.setValue(this.data.file_desc);
        this.getInCompVersions();
        if (this.data.file_comp) {
            this.compVersions = this.data.file_comp.split(',');
        }
        //   setTimeout(() => {
        // 	  this.dialogRef.close({file: this.data});
        //   }, 50000);
    };
    EditFileDialogComponent.prototype.getInCompVersions = function () {
        var _this = this;
        var comps = '';
        if (this.data.file_comp) {
            comps = this.data.file_comp.split(',');
        }
        this.http.getInCompVersions(comps)
            .subscribe(function (incompVers) {
            _this.availableVersions = incompVers;
        });
    };
    EditFileDialogComponent.prototype.removeCompVersion = function (version) {
        this.availableVersions.push(version);
        this.compVersions.splice(this.compVersions.indexOf(version), 1);
    };
    EditFileDialogComponent.prototype.addCompVersion = function (version) {
        this.availableVersions.splice(this.availableVersions.indexOf(version), 1);
        this.compVersions.push(version);
    };
    EditFileDialogComponent.prototype.submitForm = function () {
        var _this = this;
        var modeValue = this.modeSelect.value || '';
        this.data.file_mode = modeValue;
        this.data.file_desc = this.desc.value;
        if (this.compVersions.length > 0) {
            this.data.file_comp = this.compVersions.join(',');
        }
        else {
            this.data.file_comp = null;
        }
        // console.log(this.data);
        this.http.cloudEdit(this.data)
            .subscribe(function (result) {
            _this.dialogRef.close({ success: true });
        }, function (error) {
            _this.dialogRef.close({ success: false });
        });
    };
    return EditFileDialogComponent;
}(MyErrorStateMatcher));
export { EditFileDialogComponent };
